import logger from 'util/logger';

class Cache {
  public debug: boolean;

  constructor({ debug }: { debug: boolean }) {
    this.debug = debug;
  }

  private cache: Map<string, any> = new Map();

  public get(key: string): any {
    const result = this.cache.get(key);
    if (this.debug && result !== undefined) {
      logger.info(`Cache:${key}`, result);
    }
    return result;
  }

  public set(key: string, value: any): void {
    this.cache.set(key, value);
  }

  public delete(key: string): void {
    this.cache.delete(key);
  }
}

export default Cache;
